import React, { Component } from 'react';
import { getScenarioGroupInfo } from '../components/UserFunctions';

import EditScenarioGroupModal from './EditScenarioGroupModal';
import DeleteScenarioGroupModal from './DeleteScenarioGroupModal';
import { addScenarioGroupFromAPI } from '../actions/scenarioGroupAction';
import { connect } from 'react-redux';
import Pagination from './Pagination';
import PropTypes from 'prop-types';



class ScenarioGroup extends Component {
    constructor(props){
        super(props)
        this.handleEdit = this.handleEdit.bind(this);
        this.handleEditModalClose = this.handleEditModalClose.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);

        this.state = {
                editSelectedRow: undefined,
                deleteSelectedRow: undefined
            }
    }


    // class ScenarioGroup extends Component {
    //     constructor(props){
    //         super(props)
    //         this.handleEdit = this.handleEdit.bind(this);
    //         this.handleEditModalClose = this.handleEditModalClose.bind(this);
    //         this.handleDelete = this.handleDelete.bind(this);
    //         this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
    
    //         this.state = {
    //                 editSelectedRow: undefined,
    //                 deleteSelectedRow: undefined
    //             }
    //     }
    
    
    
    componentDidMount() {

        getScenarioGroupInfo().then(res => {
            if(res.data){
                this.props.dispatch(addScenarioGroupFromAPI(res));
            } else {
                this.props.dispatch(addScenarioGroupFromAPI({data: [], current_page: 0, pages: []}));
            }
        })
    }

    handleEdit(e, {index}) {
        this.setState( (prevState) => {
            return{
                editSelectedRow: index.toString(),
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }

    handleDelete(e, {index}) {
        this.setState( (prevState) => {
            return{
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: index.toString()
            }
        })
    }

    handleEditModalClose() {
        this.setState( (prevState) => {
            return{
                editSelectedRow: undefined,
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }

    handleDeleteModalClose() {
        this.setState( (prevState) => {
            return{
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: undefined
            }
        })
    }

    render() {
        console.log(this.state)
        let final_list_data = this.props.scenarioGroupData.sort(
            function (a,b) {
                    if (a.scenario_group_name > b.scenario_group_name){
                        return 1
                    }
                    else{
                        return -1
                    }
                })

        final_list_data = final_list_data.sort(
            function(a,b){
                if(a.scenario_group_name === b.scenario_group_name){
                    if(a.sequence > b.sequence){
                        return 1
                    }
                    else{
                        return -1
                    }
                }
                else{
                    return -1
                }
            }
        )
        return (
            <div className="container-fluid">
                <div className="row">
                  <div className="col mt-5 mx-auto">
                    <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card">
                            <h1 className="card-header" style={{color:"white", fontSize: "100% !important", backgroundColor: "#757AF7"}}>Scenario Group View</h1>
                        </div>
                            <div className="table col-md-6 mx-auto">
                                <div className="card-body">
                                    {this.props.scenarioGroupData.length > 0 ? <table className="table">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col" key="Scenario Group Name" style={{ textAlign: "center",verticalAlign: "top"}}>Scenario Group Name</th>
                                                <th scope="col" key="Scenario Id" style={{ textAlign: "center" ,verticalAlign: "top"}}>Scenario Id</th>
                                                <th scope="col" key="Scenario UUID" style={{ textAlign: "center",display: "none",verticalAlign: "top"}}>Scenario UUID</th>
                                                <th scope="col" key="Scenario Name" style={{ textAlign: "center", verticalAlign: "top"}}>Scenario</th>
                                                <th scope="col" key="Scenario Name" style={{ textAlign: "center" ,verticalAlign: "top"}}>Scenario Description</th>
                                                <th scope="col" key="Sequence" style={{ textAlign: "center",verticalAlign: "top" }}>Sequence</th>
                                                <th scope="col" key="Action" style={{ textAlign: "center",verticalAlign: "top" }}>Action</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                          <tbody>
                                            {final_list_data.map( (element, index) => {
                                                return (<tr key={index} className="table-row">
                                                            <td>{element.scenario_group_name}</td>
                                                            <td>{element.scenario_id}</td>
                                                            <td style={{ display: "none" }}>{element.scenario_uuid}</td>
                                                            <td>{element.scenario}</td>
                                                            <td>{element.scenario_name}</td>
                                                            <td>{element.sequence}</td>
                                                            <td>
                                                                <button
                                                                    className="btn"
                                                                    id={index}
                                                                    value={index}
                                                                    style={{ margin : "1% 1% 1% 1%" }}
                                                                    onClick={ (e) =>{ this.handleEdit(e, {index})} }
                                                                    data-toggle="tooltip" data-placement="top" title="Edit"
                                                                >
                                                                    <i className="fas fa-edit"></i>
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn"
                                                                    value={index}
                                                                    id={index}
                                                                    onClick={ (e) =>{ this.handleDelete(e, {index})} }
                                                                    data-toggle="tooltip" data-placement="top" title="Delete"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                 </button>

                                                            </td>
                                                        </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                    : <div className="alert alert-secondary" role="alert">
                                        No data available
                                      </div>}
                                </div>
                        </div>
                      </div>
                      {this.state.editSelectedRow ?
                      <EditScenarioGroupModal
                        editSelectedRow={this.state.editSelectedRow}
                        handleEditModalClose={this.handleEditModalClose}
                        content={this.props.scenarioGroupData[parseInt(this.state.editSelectedRow)]}
                      /> : undefined}

                      {this.state.deleteSelectedRow ?
                      <DeleteScenarioGroupModal
                        deleteSelectedRow={this.state.deleteSelectedRow}
                        handleDeleteModalClose={this.handleDeleteModalClose}
                        content={this.props.scenarioGroupData[parseInt(this.state.deleteSelectedRow)]}
                      /> : undefined}
                  </div>
                </div>
                  <div>
                    {this.props.scenarioGroupData.length > 0 ?
                     <Pagination
                        currentPage={this.props.currentPage}
                        pages={this.props.pages}
                        getApiInfo={getScenarioGroupInfo}
                        action={addScenarioGroupFromAPI}
                     />
                     : undefined}
                  </div>
              </div>
        )
    }
}
ScenarioGroup.propTypes={
scenarioGroupData:PropTypes.string,
dispatch:PropTypes.string,
currentPage:PropTypes.string,
pages:PropTypes.string,
}
ScenarioGroup.defaultProps= {
scenarioGroupData:[],
dispatch:[],
currentPage:[],
pages:[],
}
// ScenarioGroup.propTypes={
//     scenarioGroupData:PropTypes.string,
//     dispatch:PropTypes.string,
//     currentPage:PropTypes.string,
//     pages:PropTypes.string,
//     }
//     ScenarioGroup.defaultProps= {
//     scenarioGroupData:[],
//     dispatch:[],
//     currentPage:[],
//     pages:[],
//     }
    
// const mapStateToProps = (state) => {
//     return{
//         scenarioGroupData: state.scenarioGroup.scenarioGroup,
//         currentPage: state.scenarioGroup.currentPage,
//         pages: state.scenarioGroup.pages
//     }
// }

// export default connect(mapStateToProps)(ScenarioGroup);

const mapStateToProps = (state) => {
    return{
        scenarioGroupData: state.scenarioGroup.scenarioGroup,
        currentPage: state.scenarioGroup.currentPage,
        pages: state.scenarioGroup.pages
    }
}

export default connect(mapStateToProps)(ScenarioGroup);
